import { type PropsWithChildren } from 'react';

import TableCell, { type TDProps } from '../TableCell';

type Props = TDProps;

const TD: React.FC<PropsWithChildren<Props>> = ({ children, ...props }) => (
  <TableCell {...props} head={false}>
    {children}
  </TableCell>
);

export default TD;
